import { create } from 'zustand';
import { useSettings } from '@/store/settings';

/**
 * The PILOT's own position (browser geolocation, fetched from the TopBar
 * pin). Session-only — a laptop moves. Consumed by the TopBar readout and
 * the MapView pilot marker.
 */
interface OperatorPosStore {
  pos: { lat: number; lon: number } | null;
  set: (pos: { lat: number; lon: number } | null) => void;
}

export const useOperatorPos = create<OperatorPosStore>((set) => ({
  pos: null,
  set: (pos) => set({ pos }),
}));

/** Ask the browser for the pilot's position and store it. Fire-and-forget. */
export function fetchOperatorPos(): void {
  if (!('geolocation' in navigator)) return;
  navigator.geolocation.getCurrentPosition(
    (p) => useOperatorPos.getState().set({ lat: p.coords.latitude, lon: p.coords.longitude }),
    () => {},
    { enableHighAccuracy: true, timeout: 10_000 },
  );
}

// "Home follows pilot" (Settings → Map): every pilot-position update
// rewrites the home position while the toggle is on.
useOperatorPos.subscribe((s) => {
  const pos = s.pos;
  if (!pos) return;
  const settings = useSettings.getState();
  if (settings.map.homeFollowsPilot) {
    settings.setMap({
      initialLat: Number(pos.lat.toFixed(6)),
      initialLon: Number(pos.lon.toFixed(6)),
    });
  }
});
